import React from "react";
import "../../css/components/tool_tips/DefaultTooltip.css";

const DefaultTooltip = ({ text, children }) => {
    return (
        <div className="tooltip-wrapper">
            {children}
            <span className="tooltip-box">{text}</span>
        </div>
    );
};

export default DefaultTooltip;
